import request from '@/utils/request'
// 生成时间:2022-06-09 17:37:52

// 查询documenttype列表
export function listDocumenttype(query) {
    var data={
        filterstr:"",
        orderby:"",
        opstr:query.opstr ||{},
        page_size:query.pageSize,
        page:query.pageNum
    };
    var filterstr={};
    for(var k in query){
     var item=query[k];
     if(k!="pageSize" && k!="pageNum"&&k!="opstr"){
       filterstr[k]=item;
     }
    }
    data["filterstr"] = JSON.stringify(filterstr);
    data["opstr"] = JSON.stringify(data["opstr"]);
    return request({
        url: '/general/documenttype/list',
        method: 'post',
        data: data
    })
}

// 查询documenttype详细
export function getDocumenttype (id) {
    return request({
        url: '/general/documenttype/get?id='+id,
        method: 'get'
    })
}


// 新增documenttype
export function addDocumenttype(data) {
    return request({
        url: '/general/documenttype/add',
        method: 'post',
        data: data
    })
}

// 修改documenttype
export function editDocumenttype(data) {
    return request({
        url: '/general/documenttype/edit',
        method: 'post',
        data: data
    })
}

// 删除documenttype
export function delDocumenttype(ids) {
    return request({
        url: '/general/documenttype/del',
        method: 'post',
        data:{ids:ids}
    })
}

// 删除documenttype查询模板
export function advquerydelDocumenttype(ids) {
    return request({
        url: '/general/documenttype/advquerydel',
        method: 'post',
        data:{ids:ids}
    })
}

// 添加documenttype查询模板
export function advquerysaveDocumenttype(data) {
    return request({
        url: '/general/documenttype/advquerysave',
        method: 'post',
        data: data
    })
}
// 列表documenttype查询模板列表
export function advquerylistDocumenttype(businessname) {
    return request({
        url: '/general/documenttype/advquerylist?businessname='+businessname,
        method: 'get'
    })
}
// 导出documenttype
export function exportDocumenttype(query,exportfields,tableColumn) {
     var data={
            filterstr:"",
            orderby:"",
            opstr:query.opstr ||{},
        };
        var filterstr={};
        for(var k in query){
         var item=query[k];
         if(k!="pageSize" && k!="pageNum"&&k!="opstr"){
           filterstr[k]=item;
         }
        }
        var tarexportfieldslist={};
        for(var k in tableColumn){
          var tlbf = tableColumn[k];
           for(var i in exportfields){
             var ef = exportfields[i]
             if(tlbf.field!="" && tlbf.field && tlbf.field!=null && tlbf.field == ef){
               tarexportfieldslist.push({"filed":ef,"title":tlbf.title});
               break;
             }
           }
        }

        data["filterstr"] = JSON.stringify(filterstr);
        data["opstr"] = JSON.stringify(data["opstr"]);
        data["exportfields"] = JSON.stringify(tarexportfieldslist);
        return request({
            url: '/general/documenttype/export',
            method: 'post',
            data: data
        })
}
